import React from 'react';
import PropTypes from 'prop-types';

import CustomScrollbar, {CustomScrollbarTrackVisibility} from '../../../../lib/custom-scrollbar/custom-scrollbar';
import {OEObjectModelValueCellStyleOptions, OEObjectModelValueEditHelper} from '../oe-object-model-value-edit-model';
import OEObjectModelValueCell from './oe-object-model-value-cell';
import OEObjectModelValueCellFactory from '../oe-object-model-value-cell-factory';

export default class OEObjectModelGroupCell extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            scrollbarVisible: true
        };

        this.onVerticalScrollbarParamsChanged = this.onVerticalScrollbarParamsChanged.bind(this);
    }

    render()    {
        let {subItems, ...rest} = this.props;

        let cells = null;
        if(subItems)    {
            cells = subItems.map((item, index) => {
                const className = this.props.cellClassName + (item.className ? ' ' + item.className : '') + (index == 0 ? ' first' : '') + (index == subItems.length - 1 ? ' last' : '');
                const disabled = this.props.disabled || !!item.disabled;

                return (
                    <OEObjectModelValueCellFactory
                        key={index}
                        {...item}
                        className={className}
                        cellClassName={this.props.cellClassName}
                        disabled={disabled}
                        onChange={this.props.onChange}
                    />
                );
            });
        }

        if(OEObjectModelValueEditHelper.includesCellStyleOption(this.props.styleOptions, OEObjectModelValueCellStyleOptions.scrollable))    {

            let className = rest.className + (this.state.scrollbarVisible ? ' scrollbar-visible' : '');

            return (
                <OEObjectModelValueCell {...rest} className={className}>
                    <CustomScrollbar
                        horizontalTrackVisiblity={CustomScrollbarTrackVisibility.none}
                        verticalTrackVisiblity={CustomScrollbarTrackVisibility.auto}
                        onVerticalParamsChanged={this.onVerticalScrollbarParamsChanged}
                    >
                        {cells}
                    </CustomScrollbar>
                </OEObjectModelValueCell>
            );
        } else {
            return (
                <OEObjectModelValueCell {...rest}>
                    {cells}
                </OEObjectModelValueCell>
            );
        }
    }

    onVerticalScrollbarParamsChanged(sender, params)    {
        this.setState({scrollbarVisible: params.trackVisible});
    }
};

OEObjectModelGroupCell.defaultProps = Object.assign({
    disabled:                   false
}, OEObjectModelValueCell.defaultProps);

OEObjectModelGroupCell.defaultProps.showType = false;

OEObjectModelGroupCell.propTypes = Object.assign({
    cellClassName:              PropTypes.string,
    disabled:                   PropTypes.bool,
    subItems:                   PropTypes.arrayOf(PropTypes.object),
}, OEObjectModelValueCell.propTypes);